import { makeStyles } from '@mui/styles';
import { width } from '@mui/system';
import theme from 'src/style-system/theme';

export const useStyles = ({ variation }: any) => {
  const SECOND_VARIATION = 'imageOnRightSide';

  return makeStyles({
    mainContainer: {
      padding: '40px 50px',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme.palette.whitePepper.main,
    },

    container: {
      width: '100%',
      maxWidth: '1050px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '30px',
      flexDirection:
        variation === SECOND_VARIATION ? 'column-reverse' : 'column',
      [theme.breakpoints.up(720)]: {
        flexDirection: variation === SECOND_VARIATION ? 'row-reverse' : 'row',
      },
    },

    imgSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      rowGap: '20px',

      [theme.breakpoints.up(720)]: {
        flexGrow: variation === SECOND_VARIATION ? 1 : 0,
      },
      [theme.breakpoints.down(720)]: {
        width: '100%',
      },
    },

    imgWrapper: {
      flexShrink: 0,
      position: 'relative',
      height: '250px',
      width: '250px',
    },

    textWrapper: {
      flexBasis: '50%',
      maxWidth: '525px',
    },

    listItem: {
      '&::marker': {
        fontSize: '22px',
        lineHeight: '28px',
        color: theme.palette.cinnamon.main,
      },
    },

    unorderedlist: {
      //margin: '0 0 16x',
    },

    unorderedlistItem: {
      '&::marker': {
        color: theme.palette.cinnamon.main,
      },
    },
  });
};
